import { useState } from "react"
import { Box, IconButton, Stack, Typography } from "@mui/material"
import { ChevronLeft, ChevronRight, PhotoLibrary } from "@mui/icons-material"

const VehicleImageSlideshow = ({ images = [], alt = "Vehicle" }) => {
    const [index, setIndex] = useState(0)
    const safeImages = images.length ? images : [""]
    const current = safeImages[index] || safeImages[0]

    const go = (direction) => {
        setIndex((prev) => {
            const next = prev + direction
            if (next < 0) return safeImages.length - 1
            if (next >= safeImages.length) return 0
            return next
        })
    }

    return (
        <Box>
            <Box
                sx={{
                    position: "relative",
                    borderRadius: 2,
                    overflow: "hidden",
                    bgcolor: "#eef2f7",
                    border: "1px solid rgba(0, 4, 53, 0.08)",
                }}
            >
                <Box
                    sx={{
                        width: "100%",
                        paddingBottom: { xs: "68%", md: "62%" },
                        backgroundImage: current ? `url('${current}')` : undefined,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                    }}
                    role="img"
                    aria-label={`${alt} — image ${index + 1} of ${safeImages.length}`}
                />

                <Stack
                    direction="row"
                    alignItems="center"
                    spacing={0.5}
                    sx={{
                        position: "absolute",
                        top: 14,
                        left: 14,
                        px: 1.25,
                        py: 0.5,
                        borderRadius: 1,
                        bgcolor: "rgba(0, 4, 53, 0.72)",
                        color: "#fff",
                    }}
                >
                    <PhotoLibrary sx={{ fontSize: 16 }} />
                    <Typography variant="caption" fontWeight={700}>
                        {index + 1} / {safeImages.length}
                    </Typography>
                </Stack>

                {safeImages.length > 1 && (
                    <>
                        <IconButton
                            onClick={() => go(-1)}
                            aria-label="Previous image"
                            sx={{
                                position: "absolute",
                                top: "50%",
                                left: 10,
                                transform: "translateY(-50%)",
                                bgcolor: "rgba(255,255,255,0.95)",
                                boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
                                "&:hover": { bgcolor: "#fff" },
                            }}
                        >
                            <ChevronLeft />
                        </IconButton>
                        <IconButton
                            onClick={() => go(1)}
                            aria-label="Next image"
                            sx={{
                                position: "absolute",
                                top: "50%",
                                right: 10,
                                transform: "translateY(-50%)",
                                bgcolor: "rgba(255,255,255,0.95)",
                                boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
                                "&:hover": { bgcolor: "#fff" },
                            }}
                        >
                            <ChevronRight />
                        </IconButton>
                    </>
                )}
            </Box>

            {safeImages.length > 1 && (
                <Stack
                    direction="row"
                    spacing={1}
                    sx={{
                        mt: 1.5,
                        overflowX: "auto",
                        overflowY: "hidden",
                        pb: 0.5,
                        width: "100%",
                        maxWidth: "100%",
                        minWidth: 0,
                        WebkitOverflowScrolling: "touch",
                    }}
                >
                    {safeImages.map((image, thumbIndex) => (
                        <Box
                            key={thumbIndex}
                            component="button"
                            type="button"
                            aria-label={`View image ${thumbIndex + 1}`}
                            onClick={() => setIndex(thumbIndex)}
                            sx={{
                                flex: "0 0 auto",
                                width: 88,
                                height: 62,
                                p: 0,
                                border: "2px solid",
                                borderColor: thumbIndex === index ? "#00A3FF" : "rgba(0, 4, 53, 0.1)",
                                borderRadius: 1.5,
                                overflow: "hidden",
                                cursor: "pointer",
                                bgcolor: "#eef2f7",
                                backgroundImage: image ? `url('${image}')` : undefined,
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                            }}
                        />
                    ))}
                </Stack>
            )}
        </Box>
    )
}

export default VehicleImageSlideshow
